import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import type { ScopeActivationItem, ScopeItemRow } from "@/api/scope-activation";

import { eligibilityLabel } from "./aderenciaData";
import { CapabilityEvidence } from "./CapabilityEvidence";

function Field({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex gap-3 border-b py-1.5 last:border-b-0">
      <div className="w-[20%] shrink-0 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
        {label}
      </div>
      <div className="flex-1 text-xs">{value}</div>
    </div>
  );
}

/**
 * Drilldown horizontal de um scope item: por que a árvore sugeriu o que
 * sugeriu, o motivo do analista (quando houver) e a evidência técnica do ERP
 * por capacidade — tudo ligado ao mesmo scope_item_id.
 */
export function CatalogDrilldown({
  row,
  activationItem,
}: {
  row: ScopeItemRow;
  activationItem?: ScopeActivationItem;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col rounded-md border bg-muted/30 p-3">
      <Field
        label={t("Suggestion")}
        value={
          <>
            <span className="font-medium">{t(eligibilityLabel(row.suggestion))}</span>
            {row.suggestion_reason && (
              <span className="ml-2 text-muted-foreground">
                {row.suggestion_reason}
              </span>
            )}
          </>
        }
      />
      {row.analyst_verdict && (
        <Field
          label={t("Analyst verdict")}
          value={
            <>
              <span className="font-medium">
                {t(eligibilityLabel(row.analyst_verdict))}
              </span>
              {row.analyst_reason && (
                <span className="ml-2 text-muted-foreground">
                  {row.analyst_reason}
                </span>
              )}
            </>
          }
        />
      )}
      <Field
        label={t("ERP evidence")}
        value={
          <CapabilityEvidence
            item={
              activationItem ?? {
                capability_details: [],
                triggered_by: [],
                s4_targets: [],
              }
            }
            emptyHint={t("No ERP signal captured for this item.")}
          />
        }
      />
    </div>
  );
}
